class Utils {
  static PRODUCT_VIEWED_FIRST = 'theme.product_viewed_first';
  static SEARCH_SUBMITTED = 'theme.search_submitted';
  static VARIANT_CHANGED = "theme.variant_changed";
  static VARIANT_SELECTED_CLICKED = "theme.variant_selected_clicked";
  static VARIANT_LOADED = "theme.variant_picker_loaded";
  static WISHLIST_ADDED = "theme.wishlist_added";
  static WISHLIST_REMOVED = "theme.wishlist_removed";
  static CART_ADDING = "theme.adding_to_cart";
  static CART_ADDED = "theme.added_to_cart";
  static CART_ADD_ERROR = "theme.added_to_cart_error";
  static RANGE_CHANGED = "theme.range_changed";

  static VIEWED = 'viewed';
  static SEARCHED = 'searched';
  static WISHLIST = 'wishlist';

  static money = (amount) => {
    const a = (amount/100).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return window.currencyFormat.replace('{{amount}}', a).replace('{{amount_with_comma_separator}}', a);
  }

  static getParentByTagName = (element, tagName) => {
    while (element.tagName !== tagName.toUpperCase() && element.tagName !== 'BODY') {
      element = element.parentElement;
    }
    return element;
  }

  static error = (message, data) => {
    /*Swal.fire({
      title: window.lang.errors.title,
      text: message,
      icon: "error",
      customClass: {
        confirmButton: 'btn btn-primary'
      }
    });*/
  }

  static addTocart = (data) => {
    if(data.form == undefined)
      Utils.error(window.lang.errors.generic, 'Form not found');
    else {
      const formdata = new FormData(data.form);
      if(formdata.get('quantity') == undefined || formdata.get('quantity') == '' || formdata.get('quantity') == null || !(parseInt(formdata.get('quantity')) > 0))
        Utils.error(window.lang.errors.generic, 'Quantity not found');
      else if(formdata.get('id') == undefined || formdata.get('id') == '' || formdata.get('id') == null)
        Utils.error(window.lang.errors.variants);
      else {
        window.dispatchEvent(new CustomEvent(Utils.CART_ADDING, { detail: formdata.get('id') }));
        if(typeof data.beforeAdd == 'function')
          data.beforeAdd(formdata.get('id'));

        axios.post(window.Shopify.routes.root + 'cart/add.js', formdata)
        .then((response) => {
          try {
            const added = JSON.parse(response.request.responseText);
            if(typeof data.afterAdd == 'function')
              data.afterAdd(added);
            window.dispatchEvent(new CustomEvent(Utils.CART_ADDED, { detail: added }));
          } catch (e){
            window.dispatchEvent(new CustomEvent(Utils.CART_ADD_ERROR, { detail: e }));
            Utils.error(window.lang.errors.generic, e);
          }
        })
        .catch((error) => {
          window.dispatchEvent(new CustomEvent(Utils.CART_ADD_ERROR, { detail: error }));
          Utils.error(error.response.data.description || error.message, error);
        })
        .finally(() => {
          if(typeof data.finally == 'function')
            data.finally();
        });
      }
    }
  }

  static getViewed = () => {
    return localStorage.getItem(Utils.VIEWED) ? localStorage.getItem(Utils.VIEWED).split(',') : [];
  }

  static getSearched = () => {
    return localStorage.getItem(Utils.SEARCHED) ? localStorage.getItem(Utils.SEARCHED).split(',') : [];
  }

  static getWishlist = () => {
    return localStorage.getItem(Utils.WISHLIST) ? localStorage.getItem(Utils.WISHLIST).split(',') : [];
  }

  static getProductByHandle = (handle, callback) => {
    axios.get(window.Shopify.routes.root + 'products/'+handle+'.js', {responseType: 'json'})
    .then((response) => {
      try {
        if(typeof callback == 'function')
          callback(JSON.parse(response.request.responseText));
      } catch (e){
        Utils.error(window.lang.errors.generic, e);
      }
    })
    .catch((error) => {
      Utils.error(error.message, error);
    });
  }
}

window.activateTooltips = () => {
  document.querySelectorAll('.tooltip').forEach((tooltip) => {
    tooltip.remove();
  });
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
  console.log(tooltipList);
}

activateTooltips();


class ScrollingText extends HTMLElement {
  displayed;

  connectedCallback() {
    this.displayed = getComputedStyle(document.documentElement).getPropertyValue("--marquee-elements-displayed");
    this.init();
  }

  init = () => {
    document.documentElement.style.setProperty("--marquee-elements", this.children.length);
    for(var i=0; i<this.displayed; i++){
      this.appendChild(this.children[i].cloneNode(true));
    }
  }
}
if (!window.customElements.get("scrolling-text")) {
  window.customElements.define("scrolling-text", ScrollingText);
}